import client from '../../utils/client';
import services from '../../utils/services';

export async function loadAllFleetsApi() {
  return client.get(services.getAllFleets, {});
}
